import './dealmedTextInput.scss'

const DealmedTextInput = ({ value, label, name, placeholder, type, onChange, disabled }) => {
  return (
    <div className="form-group">
      {label && <label htmlFor="input-field">{label}</label>}
      <input
        type={type}
        value={value}
        name={name}
        className="form-control"
        placeholder={placeholder}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  )
}

const DealmedTextArea = ({ value, label, name, placeholder, type, onChange, rows }) => {
  return (
    <div className="form-group">
      {label && <label htmlFor="input-field">{label}</label>}
      <textarea
        type={type}
        value={value}
        name={name}
        className="form-control"
        placeholder={placeholder}
        onChange={onChange}
        rows={rows}
      />
    </div>
  )
}

export { DealmedTextInput, DealmedTextArea }
